import { TypedLocale } from 'payload';

import { CMSLink } from '@/components/Link';
import { CasesSpot } from '@/payload-types';
import { cn } from '@/utils/cn';

import styles from './CasesSpot.module.scss';

type Props = {
  className?: string;
  casesSpot: CasesSpot;
  locale?: TypedLocale;
};

export const CasesSpotClient: React.FC<Props> = (props) => {
  const { casesSpot, className, locale } = props;
  if (!casesSpot) return null;

  const { description, link, title } = casesSpot;

  return (
    <div className={cn(styles.spot, className)}>
      {title && <div className={styles.title}>{title}</div>}
      {description && <div className={styles.description}>{description}</div>}
      {link && (
        <CMSLink
          locale={locale}
          {...link}
          appearance='level-1'
          className={cn(styles.link, 'button--medium')}
        />
      )}
    </div>
  );
};
